import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchSuccessPatchAddResidentToUnit } from './dispatch-success-patch';
import { AddResidentToUnitQueryArg } from '../types/query-arg';

export const handleResultAddResidentToUnit: QueryHandler<
  AddResidentToUnitQueryArg,
  void
> = async (queryArg, { queryFulfilled, ...api }) => {
  await queryFulfilled;
  dispatchSuccessPatchAddResidentToUnit(queryArg, api);
};
